import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../data/lenders";

export const FAQSection = ({ items = FAQS, title = "Frequently Asked Questions" }) => (
  <section data-testid="faq-section" className="bg-[#F7F9FC]">
    <div className="ol-container ol-section">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <p className="text-xs uppercase tracking-[0.2em] text-[#1088D4] font-semibold">FAQs</p>
        <h2 className="mt-2 text-3xl sm:text-4xl font-bold text-[#273B59] font-heading">{title}</h2>
      </div>
      <Accordion type="single" collapsible className="max-w-3xl mx-auto">
        {items.map((f, i) => (
          <AccordionItem key={i} value={`f-${i}`} className="border border-[#E2E8F0] bg-white rounded-lg mb-3 px-5">
            <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left font-semibold text-[#273B59] hover:no-underline">{f.q}</AccordionTrigger>
            <AccordionContent className="text-[#475569] text-sm leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
